import DealerSelect from "./dealer-select";

const DealerFormItems = {
    Select: DealerSelect,
};

export default DealerFormItems;